/**
 * Reads the tenant's appConfig out of browser storage.
 *
 * Callers used to do `JSON.parse(localStorage.getItem('appConfig'))` and then test
 * `'key' in appConfig`, which throws on a fresh session (the item is absent, so the
 * parse yields null) and on corrupt storage. Always returns an object so an `in` test
 * is safe. Deliberately not memoized: a cached copy would survive a Configuration
 * change or a TOC switch and hand callers stale settings.
 */
export function readAppConfig(): any {
    try {
        const raw = JSON.parse(localStorage.getItem('appConfig'));
        return raw && typeof raw === 'object' ? raw : {};
    } catch {
        return {};
    }
}
